/**
 * @author Yaochao
 * @date 2022/3/31 18:03
 * @description
 */
import Notify from '@wcjiang/notify';

class MyNotify {

    constructor() {
        this.notify = new Notify({
            effect: 'flash',
            interval: 1000,
            audio: {
                file: 'https://zk-cloud.oss-cn-beijing.aliyuncs.com/static/wxwork_message.mp3'
            },
            disableFavicon: true,
        });
        this.isEnter = true;
    }

    start(title) {
        this.notify.player();
        if (!this.isEnter) {
            this.notify.setTitle(true) // 播放动画
            this.notify.setTitle(title ? title : '你有新的消息') // 闪烁新标题
        }
    }

    stop() {
        this.notify.setTitle() // 闪烁新标题
    }

    /**
     * 页面进入
     */
    enter() {
        this.isEnter = true;
    }

    /**
     * 页面离开
     */
    leave() {
        this.isEnter = false;
    }
}

export default MyNotify